export function getMainPlan(plans) {
	return plans.find(item => item.main && item.active);
}

export function getPriceById(id, plans = []) {
	if (!id) return null;
	for (const plan of plans) {
		const override = plan.overrides?.find(
			item => item.id.toString() === id.toString()
		);

		if (override) {
			return {
				...plan,
				baseAmount: override.baseAmount,
				currency: override.currency,
				active: override.active,
				handlerId: override.id
			};
		}
	}

	return null;
}

export function getPriceByIdAndCurrency(id, currency, plans = []) {
	if (!id) return null;

	if (!currency) {
		return getPriceById(id, plans);
	}

	for (const plan of plans) {
		const hasOriginalOverride = plan.overrides?.some(
			item => item.id.toString() === id.toString()
		);

		if (!hasOriginalOverride) continue;

		const currencyOverride = plan.overrides?.find(
			item =>
				item.currency?.toLowerCase() === currency.toLowerCase() &&
				item.active
		);

		if (!currencyOverride) return null;

		return {
			...plan,
			baseAmount: currencyOverride.baseAmount,
			currency: currencyOverride.currency,
			active: currencyOverride.active,
			handlerId: currencyOverride.id
		};
	}

	return null;
}
